// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__nr4cH","rightAdornment":"Header_rightAdornment__1NZK2"};